import {getFeaturesFromParent} from "../handler/ParentDataHandler";
import {chainWalk, getNodeId} from "./Util";
import {NEW_ZANCASORT_TEST_CONFIG_ENABLED_STATIONS, STOW_STATION_INSTALLATION_TYPE_ENABLED_STATIONS} from "./Constants";

export const FEATURES = {
    IS_ADTA_HAMPER_ZONING_ENABLED: "isADTAHamperZoningEnabled",
    IS_ADTF_SUBTYPE_ENABLED: "isADTFSubtypeEnabled",
    IS_DMW_PERMISSIONS_ENABLED: "isDMWPermissionsEnabled",
    IS_MHE_VALIDATION_ENABLED: "isMHEValidationEnabled",
    IS_RFID_BAGS_ENABLED: "isRFIDBagsEnabled",
    IS_SSD_2_X_ENABLED: "isSSD2XSiteEnabled",
    IS_SSD3_ENABLED: "isSSD3SiteEnabled",
    IS_LED_CONTROLLER_ENHANCEMENT_ENABLED: "isLedControllerEnhancementEnabled",
    IS_NEW_ZANCASORT_TEST_CONFIG_ENABLED: "isNewZancasortTestConfigEnabled",
    IS_MULTIPLE_BULKY_SLIDES_FOR_DROP_TO_CART_ENABLED: "isMultipleBulkySlidesForDropToCartEnabled",
    IS_MULTIPLE_FRAGILE_SLIDES_ENABLED_FOR_SSD: "isMultipleFragileSlidesForSSDEnabled",
    IS_PROBLEM_SOLVE_ON_GRID_SORTATION_FLOW_ENABLED: "isPSOnGridSortationFlowEnabled",
    IS_BIN_INSTALLATION_TYPE_ENABLED: "isBinInstallationTypeEnabled",
    IS_ADTA_DEVICE_HEALTH_STATUS_API_ENABLED: "isAdtaDeviceHealthStatusAPIEnabled",
    IS_IN_SITE_ENABLED: "isINSiteEnabled",
    IS_STOW_STATION_INSTALLATION_TYPE_ENABLED: "isStowStationInstallationTypeEnabled",
    IS_VAPR_FOV_ENABLED: "isVaprFovEnabled",
    IS_LED_CONTROLLER_IP_CAPTURE_ENABLED: "isLedControllerIpCaptureEnabled"
}

/**
 * Use this class whenever there is a requirement whenever a feature context variable
 * is required to be used for both components and other objects.
 */
export class FeatureUtility {
    static featureStatus = {};

    static getFeatureStatus(featureName) {
        return chainWalk(() => FeatureUtility.featureStatus[featureName], false);
    }

    static setAllFeatureStatuses() {
        return getFeaturesFromParent(Object.values(FEATURES)).then(featureStatusResponse => {
            Object.values(FEATURES).forEach((featureName) => {
                FeatureUtility.featureStatus[featureName] =
                    chainWalk(() => featureStatusResponse.data[featureName], false)
            })
        });
    }
}

// A feature is on if the current station is listed or its SCC flag is on. Read at call time,
// because flags arrive from SCC after modules load.
const isEnabledForStationOrFlag = (stations, featureName) =>
    stations.includes(getNodeId()) || FeatureUtility.getFeatureStatus(featureName);

/**
 * Whether ZancaSort uses the new test config (Scannables, SortZone, Bags) instead of the old one
 * (Scannables, Destination).
 */
export function isNewZancaSortTestConfigEnabled() {
    return isEnabledForStationOrFlag(NEW_ZANCASORT_TEST_CONFIG_ENABLED_STATIONS,
        FEATURES.IS_NEW_ZANCASORT_TEST_CONFIG_ENABLED);
}

/**
 * Whether ADTF offers the Stow Station installation type (Dual Stow Operation).
 */
export function isStowStationInstallationTypeEnabled() {
    return isEnabledForStationOrFlag(STOW_STATION_INSTALLATION_TYPE_ENABLED_STATIONS,
        FEATURES.IS_STOW_STATION_INSTALLATION_TYPE_ENABLED);
}



// WEBPACK FOOTER //
// ./src/components/util/FeatureUtility.js